export enum VirtualDrivers {
	DEPARTURE_ONE = 'nRtlZk44k2LRBnXWn0bAyDKKxa2ZyAGS',
	DEPARTURE_SECOND = 'l3gNTlAlFRtaxC4rKlYRP5SSpE22zvKL',
	PROGRAM_ONE = 'wfJPVSKaqiYRGHxS0RFCBrhVnxHqCC9a',
	PROGRAM_SECOND = 'yRA2UIBRyEVhvt42wUF5YnOiUcU1pT5t',
	RETURN_ONE = 'tTR7ySznYYmESzaV4TnAHpV8fiMpPdWC',
	RETURN_SECOND = 'ioXbFDV0iRzyxFvmnygRRqRNguxOYRF3',
}

export const VirtualDriversDeparture = [VirtualDrivers.DEPARTURE_ONE, VirtualDrivers.DEPARTURE_SECOND];
export const VirtualDriversProgram = [VirtualDrivers.PROGRAM_ONE, VirtualDrivers.PROGRAM_ONE];
export const VirtualDriversReturn = [VirtualDrivers.RETURN_ONE, VirtualDrivers.RETURN_SECOND];
